import type { Voucher } from '@src/domains/vouchers/types/voucher';

export const VoucherDownloadPlacement = {
  Header: 'header',
  Row: 'row',
  None: 'none',
} as const;

export type VoucherDownloadPlacement = (typeof VoucherDownloadPlacement)[keyof typeof VoucherDownloadPlacement];

interface Params {
  vouchers: Voucher[];
  hasMultipleVouchers: boolean;
  isMobile: boolean;
}

export function resolveVoucherDownloadPlacement({
  vouchers,
  hasMultipleVouchers,
  isMobile,
}: Params): VoucherDownloadPlacement {
  if (vouchers.length === 0) return VoucherDownloadPlacement.None;

  const isSplitSingle = vouchers.length === 1;

  return !hasMultipleVouchers || (isMobile && isSplitSingle)
    ? VoucherDownloadPlacement.Header
    : VoucherDownloadPlacement.Row;
}
